import { Option } from "react-bootstrap-typeahead/types/types";

export type TypeTeacherOption = {
    value: string;
    label: string;
};

const emptyTeacher: Option[] = [
    {
        value: "",
        label: "",
    },
];

const transformTeacherToOption = (teachersToTransform: any[]): Option[] => {
    return teachersToTransform.map((teacher) => {
        const docente = teacher.docente ?? teacher;

        const returnTeacher = {
            value: docente?.docenteID.toString(),
            label: `${docente.nome} - ${docente.matriculaAdp}`,
        };

        return docente ? returnTeacher : emptyTeacher;
    });
};

const getCurrentUserFromOptions = (
    loggedUserId: string,
    teachersList: any[]
): Option[] => {
    const teacherIsInList = teachersList.some(
        (teacher) => teacher.docenteID === loggedUserId
    );

    if (!teacherIsInList) {
        return emptyTeacher;
    }

    const foundedTeacher = teachersList.filter(
        (teacher) => teacher.docenteID === loggedUserId
    );

    return transformTeacherToOption(foundedTeacher);
};

export { transformTeacherToOption, getCurrentUserFromOptions };
